import React, { useEffect } from 'react';
import { useMutation } from 'react-relay';

import { ItemFragment$data } from '../../graphql/__generated__/ItemFragment.graphql';
import UpdateListItemMutation from '../../graphql/mutations/UpdateListItemMutation';
import useCommitItem from '../../hooks/useCommitItem';
import useDynamicSelector from '../../hooks/useDynamicSelector';
import { ListItemType } from '../../types';
import { ParentRefType } from './CommonLoaderListItem';

const useExternalHandler = (parentRef?: React.RefObject<ParentRefType>) => {
    const [commitUpdate] = useMutation(UpdateListItemMutation);
    const { getCommitItem } = useCommitItem();
    const childIdEdit = useDynamicSelector('listItem', 'childIdEdit');
    const parentItem = useDynamicSelector('listItem', 'parentItem');
    const connectionParentId = useDynamicSelector('listItem', 'connectionParentId');

    useEffect(() => {
        if (!parentRef?.current || !childIdEdit || !parentItem) {
            return;
        }

        if (parentRef.current.hasOwnProperty('setChild')) {
            parentRef.current.setChild(childIdEdit);
        } else {
            const listChildId = parentItem.child.split(',').map((childId) => +childId);

            const newChild =
                childIdEdit > 0
                    ? [...listChildId, childIdEdit]
                    : // use soft delete don't delete id from list
                      listChildId; //listChildId.filter((childId) => childId !== childIdEdit);

            const data: Partial<ListItemType> = {
                ...parentItem,
                child: newChild.join(','),
            };

            delete (data as any).key;
            commitUpdate(getCommitItem(data as ItemFragment$data, connectionParentId, parentItem.id));
        }
    }, [childIdEdit]);
};

export default useExternalHandler;
